import React from "react";
import { Container, Nav } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";

import AmbulatoryOpsPanel from "../components/AmbulatoryOpsPanel";
import MobileTriagePanel from "../components/MobileTriagePanel";
import NeonatalSpecialtyPanel from "../components/NeonatalSpecialtyPanel";
import StudyScreeningPanel from "../components/StudyScreeningPanel";
import TechQcWorkbenchPanel from "../components/TechQcWorkbenchPanel";

type MonitoringTabId =
  | "tech-qc"
  | "mobile-triage"
  | "ambulatory"
  | "study-screening"
  | "neonatal";

const MONITORING_TABS: Array<{
  id: MonitoringTabId;
  label: string;
  path: string;
  component: React.ComponentType;
}> = [
  {
    id: "tech-qc",
    label: "Tech QC",
    path: "/monitoring/tech-qc",
    component: TechQcWorkbenchPanel,
  },
  {
    id: "mobile-triage",
    label: "Mobile Triage",
    path: "/monitoring/mobile-triage",
    component: MobileTriagePanel,
  },
  {
    id: "ambulatory",
    label: "Ambulatory",
    path: "/monitoring/ambulatory",
    component: AmbulatoryOpsPanel,
  },
  {
    id: "study-screening",
    label: "Study Screening",
    path: "/monitoring/study-screening",
    component: StudyScreeningPanel,
  },
  {
    id: "neonatal",
    label: "Neonatal",
    path: "/monitoring/neonatal",
    component: NeonatalSpecialtyPanel,
  },
];

const getActiveTab = (pathname: string): (typeof MONITORING_TABS)[number] =>
  MONITORING_TABS.find((tab) => pathname.startsWith(tab.path)) ??
  MONITORING_TABS[0];

export default function MonitoringWorkbenchPage() {
  const location = useLocation();
  const activeTab = getActiveTab(location.pathname);
  const ActivePanel = activeTab.component;

  return (
    <Container fluid className="py-2" data-testid="monitoring-workbench-page">
      <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-2 mb-3">
        <div>
          <h1 className="h4 mb-1">Monitoring Workbench</h1>
          <div className="text-muted small">
            Signal QC, triage, ambulatory, screening, and neonatal review use
            live portal records.
          </div>
        </div>
      </div>
      <Nav
        variant="tabs"
        className="mb-3 flex-nowrap overflow-auto"
        data-testid="monitoring-workbench-tabs"
      >
        {MONITORING_TABS.map((tab) => (
          <Nav.Item key={tab.id}>
            <Nav.Link
              as={Link}
              to={tab.path}
              active={tab.id === activeTab.id}
            >
              {tab.label}
            </Nav.Link>
          </Nav.Item>
        ))}
      </Nav>
      <ActivePanel />
    </Container>
  );
}
